import React, { Component } from 'react'
import { extend } from 'lodash'
import { SearchkitManager,SearchkitProvider,
  SearchBox, RefinementListFilter, Pagination,
  HierarchicalMenuFilter, HitsStats, SortingSelector, NoHits,
  ResetFilters, RangeFilter, NumericRefinementListFilter,
  ViewSwitcherHits, ViewSwitcherToggle, DynamicRangeFilter,
  InputFilter, GroupedSelectedFilters,
  Layout, TopBar, LayoutBody, LayoutResults,
  ActionBar, ActionBarRow, SideBar } from 'searchkit'
import './index.css'

const host = "https://search-cogapp-x7o3xw2klqvyv7arrujtmzljpi.eu-west-1.es.amazonaws.com/nls-coghackterminator/"
const searchkit = new SearchkitManager(host)

const MovieHitsGridItem = (props)=> {
  const {bemBlocks, result} = props
  let url = result._source.nm_link
  const source:any = extend({}, result._source, result.highlight)
  return (
    <div className={bemBlocks.item().mix(bemBlocks.container("item"))} data-qa="hit">
      <a href={url} target="_blank">
        <img data-qa="poster" alt="book" className={bemBlocks.item("poster")} src={source.thumbnail_url} width="170" height="240"/>
        <div data-qa="title" className={bemBlocks.item("title")} dangerouslySetInnerHTML={{__html:source.nm_title}}>
        </div>
      </a>
    </div>
  )
}

const MovieHitsListItem = (props)=> {
  const {bemBlocks, result} = props
  let url = result._source.large_url
  const source:any = extend({}, result._source, result.highlight)
  return (
    <div className={bemBlocks.item().mix(bemBlocks.container("item"))} data-qa="hit">
      <div className={bemBlocks.item("poster")}>
        <img alt="presentation" data-qa="poster" src={source.large_url}/>
      </div>
      <div className={bemBlocks.item("details")}>
        <a href={url} target="_blank"><h2 className={bemBlocks.item("title")} dangerouslySetInnerHTML={{__html:source.title}}></h2></a>
        <h3 className={bemBlocks.item("subtitle")}>Released in {source.year}, rated {source.imdbRating}/10</h3>
        <div className={bemBlocks.item("text")} dangerouslySetInnerHTML={{__html:source.plot}}></div>
      </div>
    </div>
  )
}

class App extends Component {
  render() {
    return (
      <SearchkitProvider searchkit={searchkit}>
        <Layout>
          <TopBar>
            <div className="my-logo">👕👢🏍</div>
            <SearchBox autofocus={true} searchOnChange={true} prefixQueryFields={["nm_title"]}/>
          </TopBar>

        <LayoutBody>

          <SideBar>
            <RangeFilter field="page_count" id="page_count" min={0} max={526} showHistogram={true} title="Page Count"/>
            <RefinementListFilter id="concepts" title="Concepts" field="concepts.keyword" size={10}/>
            <RefinementListFilter id="location" title="Location" field="entities.location.keyword" size={10}/>
            <RefinementListFilter id="crime" title="Crime" field="entities.crime.keyword" size={10}/>
            <RefinementListFilter id="facility" title="Facility" field="entities.facility.keyword" size={10}/>
            <RefinementListFilter id="geographicfeature" title="Geographic Feature" field="entities.geographicfeature.keyword" size={10}/>
            <RefinementListFilter id="healthcondition" title="Health Condition" field="entities.healthcondition.keyword" size={10}/>
            <RefinementListFilter id="drug" title="Drug" field="entities.drug.keyword" size={10}/>
            <RefinementListFilter id="sport" title="Sport" field="entities.sport.keyword" size={10}/>
            <RefinementListFilter id="sportingevent" title="Sporting Event" field="entities.sportingevent.keyword" size={10}/>
            <RefinementListFilter id="televisionshow" title="Television Show" field="entities.televisionshow.keyword" size={10}/>

            <RefinementListFilter id="person" title="Person" field="entities.person.keyword" size={10}/>
            <RefinementListFilter id="printmedia" title="Print Media" field="entities.printmedia.keyword" size={10}/>
            <RefinementListFilter id="organization" title="Organization" field="entities.organization.keyword" size={10}/>
            <RefinementListFilter id="movie" title="Movie" field="entities.movie.keyword" size={10}/>
            <RefinementListFilter id="jobtitle" title="Job Title" field="entities.jobtitle.keyword" size={10}/>
            <RefinementListFilter id="company" title="Company" field="entities.company.keyword" size={10}/>
            <RefinementListFilter id="quantity" title="Quantity" field="entities.quantity.keyword" size={10}/>
          </SideBar>

          <LayoutResults>

            <ViewSwitcherHits
                hitsPerPage={25} highlightFields={["nm_title"]}
                hitComponents={[
                  {key:"grid", title:"Grid", itemComponent:MovieHitsGridItem, defaultOption:true},
                  {key:"list", title:"List", itemComponent:MovieHitsListItem}
                ]}
                scrollTo="body"
            />
            <NoHits suggestionsField={"title"}/>
            <Pagination showNumbers={true}/>
          </LayoutResults>

          </LayoutBody>
        </Layout>
      </SearchkitProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js